import React from 'react'
import { Link } from 'gatsby'
import Stack from 'react-bootstrap/Stack'
import Card from 'react-bootstrap/Card'
import PriceDisplay from './price-display'
import PercentageOff from './percentage-off'
import useGetPrice from '../hooks/useGetPrice'
import setQueryParams from '../utilities/setQueryParams'
import Badge from './badge'

const HEIGHT = 80
const BADGE_OFFSET = 4

export default function ProductCardMini({ product, onClick, children }) {
    const {
        name,
        shortDescription,
        url,
        category,
        includes,
        image,
        badge,
        comingSoon,
    } = product || {}

    const BORDER_RADIUS = 12
    const is_collection = includes?.length > 0
    const { price } = useGetPrice(product)

    const Element = comingSoon ? 'div' : Link
    const properties = {}
    if(!comingSoon){
        if(url?.startsWith('http')){
            properties.href = url
            properties.rel = 'noreferrer'
            properties.target = '_blank'
        } else {
            properties.to = url
        }
    }

    if (!product) return
    return (
        <Element
            {...properties}
            className="d-flex bg-white text-decoration-none h-100 position-relative"
            css={comingSoon ? {} : { '&:hover': { transform: 'scale(1.02)' }}}
            onClick={onClick}
            style={{
                gridColumn: 'span 1',
                transition: 'transform .25s ease',
                borderRadius: BORDER_RADIUS,
            }}
        >
            {/* LEFT (image and badge) */}
            <div>
                <div className='position-relative'>
                    <img
                        src={setQueryParams(image, { format: 'webp', width: HEIGHT*2 })}
                        alt=''
                        style={{
                            height: HEIGHT,
                            objectFit: 'contain',
                            borderTopLeftRadius: BORDER_RADIUS,
                        }}
                    />
    
                    {((badge || price?.promotion_price) && !comingSoon) && (
                        <Badge
                            style={{
                                top: '100%',
                                width: `calc(100% + ${BADGE_OFFSET}px)`,
                                left: -BADGE_OFFSET,
                                // width: HEIGHT + BADGE_OFFSET,
                            }}
                        >
                            {
                                badge ? badge :
                                <span style={{ textWrap: 'nowrap' }}>
                                    <PercentageOff price={price} />% OFF
                                </span>
                            }
                        </Badge>
                    )}
                </div>
            </div>

            {/* RIGHT (card) */}
            <Card
                className="border-0"
                style={{
                    padding: 16,
                    borderRadius: BORDER_RADIUS,
                }}
            >
                <Card.Body className="p-0">
                    <Card.Title
                        className="poppins fw-bold"
                        style={{
                            fontSize: 20,
                            lineHeight: '121%',
                            marginBottom: 8,
                        }}
                    >
                        {name}
                    </Card.Title>

                    {(category && category !== 'zildjian') && <Card.Subtitle
                        as='p'
                        className="fw-semibold text-uppercase text-secondary"
                        style={{ marginBottom: 8 }}
                    >
                        {
                            !category ? 'Software' :
                            category?.endsWith('s') ? category?.slice(0, -1)?.replaceAll('-', ' ') :
                            category
                        }
                    </Card.Subtitle>}

                    <Card.Text
                        dangerouslySetInnerHTML={{ __html: shortDescription }}
                        className='clamp-2'
                        css={{ '& p': { marginBottom: 0 }}}
                        style={{ fontSize: 14, marginBottom: 8 }}
                    />
                </Card.Body>

                <Card.Footer className="bg-transparent border-0 p-0">
                    {!comingSoon && <Stack direction="horizontal" className="justify-content-between">
                        <PriceDisplay
                            product={product}
                            className='d-flex align-items-center gap-2'
                            style={{
                                fontSize: 18,
                                fontWeight: 600,
                            }}
                        />
                        {is_collection && (
                            <img
                                src='/svg/is-collection-icon-black.svg' alt=''
                                title='Type: Collection'
                            />
                        )}
                    </Stack>}
                </Card.Footer>
            </Card>

            {comingSoon && <div
                className='position-absolute'
                style={{
                    inset: 0,
                    background: 'rgba(255 255 255 / .5)',
                    borderRadius: 'inherit',
                }}
            />}

            {comingSoon && (
                <Badge style={{
                    top: 80,
                    width: 80 + BADGE_OFFSET,
                    left: -BADGE_OFFSET,
                }}>
                    COMING SOON
                </Badge>
            )}
        </Element>
    )
}
